// Fetch list

export const FETCH = 'reportCostCenterPerformance.FETCH'
export const FETCH_STARTED = 'reportCostCenterPerformance.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCostCenterPerformance.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCostCenterPerformance.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCostCenterPerformance.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportCostCenterPerformance.CLEAR'

// Export

export const EXPORT = 'reportCostCenterPerformance.EXPORT'
export const EXPORT_FULFILLED = 'reportCostCenterPerformance.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportCostCenterPerformance.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportCostCenterPerformance.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportCostCenterPerformance.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportCostCenterPerformance.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportCostCenterPerformance.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportCostCenterPerformance.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportCostCenterPerformance.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportCostCenterPerformance.EXPORT_DETAILS_FULFILLED'
